import React, { Fragment } from 'react';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import { TextPlaceholder } from "../../../elements/TextPlaceholder";
import { Divider } from "../../../elements/Divider";
export var getCardsPlaceholderMarkup = function getCardsPlaceholderMarkup() {
  return React.createElement(Fragment, null, ['first', 'second', 'third'].map(function (item) {
    return React.createElement(Card, {
      fluid: true,
      key: item
    }, React.createElement(Card.Content, null, React.createElement(Divider, null), React.createElement(TextPlaceholder, {
      length: "short"
    }), React.createElement(Divider, null), React.createElement(TextPlaceholder, {
      length: "medium"
    }), React.createElement(TextPlaceholder, {
      length: "medium"
    }), React.createElement(TextPlaceholder, {
      length: "medium"
    }), React.createElement(Divider, {
      size: "huge"
    }), React.createElement(TextPlaceholder, null), React.createElement(Divider, null), React.createElement(TextPlaceholder, null), React.createElement(Divider, null), React.createElement(TextPlaceholder, null), React.createElement(Divider, null)));
  }));
};